<template>
    <div>
        <p class="heading tw-mt-4">Overall Rating</p>
        <div class="ratings-container">
            <div class="d-flex">
                <span id="average-rating">{{ calculatedAvgRating }}</span>
                <span id="max-rating"> /{{ maxRating }}</span>
            </div>
            <div>
                <div class="container">
                    <div class="d-inline-flex">
                        <IconStar v-for="i in maxRating" :key="i" class="star" />
                    </div>
                    <div class="overlay" :style="{ width: `${100 - percentage}%` }" />
                </div>
            </div>
            <div id="count">{{ totalReviewsCount }} Total Reviews</div>
        </div>
        <div>
            <p class="heading mt-5">Rating Breakdown</p>
            <div class="my-4">
                <div v-for="rating, index of ratingsBreakdown" class="rating-row" :key="index">
                    <div style="width: 10%;" class="d-inline-flex align-items-center justify-content-between">
                        <span class="mr-2">{{ rating.rating  }}</span>
                        <IconStar class="star text-center" />
                    </div>
                    <span class="ratings-group">
                        <span class="inactive-ratings-bar"></span>
                        <span class="active-ratings-bar" :style="{width: `${rating.per}%`, 'background-color': `${barColors[index]}`}"></span>
                    </span>
                    <span class="text-center" style="color: #CECECE;">{{ rating.count }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IconStar from '../../../assets/IconStar.vue';
export default {
    name: "ReviewsAndRatings",
    components: {
        IconStar
    },
    props: {
        ratingsData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            maxRating: 5,
            avgRating: 0,
            ratingsBreakdown: [],
            totalReviewsCount: "",
            barColors: ['#065559', '#6AB7A8', '#B5DBD4', '#9ABABC', '#DAEDE9', '#76999A']
        }
    },
    mounted() {
        this.avgRating = this.ratingsData.avg_ratings;
        this.ratingsBreakdown = this.ratingsData.ratings;
        this.totalReviewsCount = this.ratingsData.total_ratings;
    },
    computed: {
        calculatedAvgRating() {
            return this.avgRating.toFixed(2);
        },
        percentage() {
            return (this.avgRating / this.maxRating) * 100;
        },
    },
}
</script>
<style>
.rating-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 10%;
}
.ratings-group {
    display: grid;
    width: 80%;
    height: 25px;
    border: 1px solid #D9D9D9;
    border-radius: 10px;
    & > * {
        grid-column: 1;
        grid-row: 1;
    }
}

.inactive-ratings-bar {
    width: 100%;
    background-color: #F4F4F4;
    border: none;
    border-radius: 10px;
}

.active-ratings-bar {
    border-radius: 10px;
}

.heading {
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.76px;
    letter-spacing: -0.01em;
    color: #065559;
    padding-bottom: 14px;
    border-bottom: 1px solid #D4D4D4;
    margin-block: 10px;
}

.ratings-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-block: 26px;
}

#average-rating, #max-rating {
    font-family: Poppins;
    font-size: 48px;
    font-weight: 500;
    line-height: 65.28px;
    letter-spacing: -0.01em;
    color: black;
    padding-bottom: 0 !important;
}

#max-rating {
    color: #CECECE;
}

#count {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    line-height: 19.04px;
    letter-spacing: -0.01em;
    color: #5E5E5E;
}

.container {
    display: grid;
    align-items: center;
    & > * {
        grid-column: 1;
        grid-row: 1;
    }
}

.star {
    display: flex;
    width: 24px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}

.overlay {
    justify-self: end;
    background-color: white;
    height: 24px;
}
</style>